var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "ma-0 pa-0", attrs: { elevation: "0" } },
    [
      _vm.model == null
        ? _c(
            "v-card",
            { attrs: { height: "20px", elevation: "0" } },
            [
              _c("v-progress-linear", {
                attrs: {
                  color: "red accent-4",
                  indeterminate: "",
                  rounded: "",
                  height: "6",
                },
              }),
            ],
            1
          )
        : _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "v-card-actions",
                { staticClass: "ma-0 pa-0" },
                [
                  _c("v-text-field", {
                    staticClass: "ma-0 pa-0 pt-1",
                    attrs: { label: "Package Name", dense: "", outlined: "" },
                    model: {
                      value: _vm.model.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "name", $$v)
                      },
                      expression: "model.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "ma-0 pa-0" },
                [
                  _c("v-text-field", {
                    staticClass: "ma-0 pa-0",
                    attrs: {
                      label: "Package Description",
                      dense: "",
                      outlined: "",
                    },
                    model: {
                      value: _vm.model.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "description", $$v)
                      },
                      expression: "model.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "ma-0 pa-0" },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      dense: "",
                      items: _vm.activationTypes,
                      outlined: "",
                      "item-text": "name",
                      "item-value": "id",
                      "return-object": "",
                      "small-chips": "",
                      "deletable-chips": "",
                      label: "Activation Type",
                    },
                    model: {
                      value: _vm.model.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "type", $$v)
                      },
                      expression: "model.type",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "ma-0 pa-0" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { outlined: "", width: "100%" },
                    },
                    [
                      _c(
                        "v-card-actions",
                        { staticClass: "ma-0 pa-2" },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "ma-0 pa-0 ml-3 grey--text" },
                            [_vm._v("users: " + _vm._s(_vm.getUsers()))]
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text pl-5 pr-3",
                              attrs: { color: "green", elevation: "0" },
                              on: { click: _vm.onPressImport },
                            },
                            [
                              _vm._v(" Import Users *.csv "),
                              _c("v-icon", { staticClass: "ml-2" }, [
                                _vm._v("mdi-database-import-outline"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text pl-5 pr-3",
                              attrs: { color: "red", elevation: "0" },
                              on: { click: _vm.onPressClearUsers },
                            },
                            [
                              _vm._v(" clear "),
                              _c("v-icon", { staticClass: "ml-2" }, [
                                _vm._v("mdi-delete"),
                              ]),
                            ],
                            1
                          ),
                          _c("input", {
                            ref: "uploader",
                            staticClass: "d-none",
                            attrs: { type: "file", accept: ".csv" },
                            on: { change: _vm.onFileChanged },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }